import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import NumberFormat from "react-number-format";
import Swal from 'sweetalert2';
import { Toaster } from 'react-hot-toast';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMale, faHandshake, faGlobeAmericas, faQuestionCircle} from "@fortawesome/free-solid-svg-icons";
import { setParametrosBusqueda } from "../actions/busqueda/busquedaAction";
import Spinner from "./Spinner";
import Alert from "./SweetAlert";
import Toast from './Toast';
import { requests } from "../constants/config";
import { EXITO, EXTRANJERO_RFC, FISICA, GENERICO, GENERICO_RFC, MORAL } from "../constants/enviroment";
import { DATOFISCAL_PAIS, DATOFISCAL_ESTADO, DATOFISCAL_MUNICIPIO, DATOFISCAL_CALLE, DATOFISCAL_COLONIA, 
         DATOFISCAL_CODIGOPOSTAL, DATOFISCAL_NUMEROEXTERIOR, DATOFISCAL_REGIMENFISCAL, DATOFISCAL_USOCFDI,
         NO_FISCALES, SOCIEDADES_MERCANTILES          
} from "../constants/datosFiscales";
import useForm from "../hooks/useForm";
import axios from "../axios";
import { datosFiscalesConstraints, datosFiscalesFormDefault } from "../views/FacturaGeneral/DatosFiscalesForm";
import beneficiario from '../assets/img/helps/razonSocial.png';
import codigoPostal from '../assets/img/helps/codigoPostal.png';

const DatosFiscales = (props) => {
    const dispatch = useDispatch();
    const usoCFDI = useSelector(state => state.usoCFDI.usosCFDI);
    var regimenFiscal = useSelector(state => state.regimenFiscal.regimenes);
    const soloGenerico = useSelector(state => state.facturacion.soloGenerico);
    const parametrosBusqueda = useSelector(state => state.parametrosBusqueda);
    const idNetsuite = useSelector(state => state.parametrosBusqueda.idNetsuite);
    const idCompra = useSelector(state => state.parametrosBusqueda.idCompra);

    const {
        handleFormChange,
        isFormValid,
        getValue,
        setPropValue
    } = useForm(datosFiscalesFormDefault, datosFiscalesConstraints);

    const [error, setErrores] = useState('');
    const [tipo, setTipo] = useState(GENERICO);
    const [otros, setOtros] = useState(false);
    const [buscando, setIsBuscando] = useState(false);
    const [asalariado, setAsalariado] = useState(false);
    const [clicked, setClicked] = useState(true);
    const [persona, setPersona] = useState(FISICA);
    const [extranjero, setExtranjero] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [searched, setSearched] = useState(false);
    const [noFiscal, setNoFiscal] = useState(false);

    if (soloGenerico) {
        datosFiscalesFormDefault.values.rfc = GENERICO_RFC;
    };

    const disabledButton = () => {
        return !isFormValid();
    };

    const setForm = async (event) => {
        handleFormChange(event);
        
        let targetName = event.target.name;
        let targetValue = event.target.value;

        if (targetName === 'rfc') {
           setRFC(targetValue); 
        }

        if(targetName === "regimenFiscal") {
            setRegimenFiscal(targetValue);
        }
    };

    const validateCorreo = (event) => {
        event.preventDefault();
        if(getValue("correo") !== getValue("correo2")) {
            setIsBuscando(false);
            Toast("Los correos ingresados deben coincidir");
            setErrores('.');
            setPropValue("correo2", "");
        }
    };

    const confirmCorreo = (event) => {
        event.preventDefault();
        Toast("Ingrese la confirmación del correo");
        setErrores('.');  
        setPropValue("correo2", "");
    };

    const setCorreo= async (event) => {
        handleFormChange(event);
    };

    const cleanForm = () => {
        setPropValue('beneficiario', "");
        setPropValue('pais', "");
        setPropValue('estado', "");
        setPropValue('municipio', "");
        setPropValue('calle', "");
        setPropValue('colonia', "");
        setPropValue('codigoPostal', "");
        setPropValue('numeroExterior', "");
        setPropValue('numeroInterior', "");
        setPropValue('correo', "");
        setPropValue('correo2', "");
        setPropValue('telefono', "");
        setPropValue('numregldtrib', "");
        setPropValue('paisFiscal', "");
        setPropValue('regimenFiscal',"");
        setPropValue('usoCFDI', "");
    };

    const setFormData = (datosFacturacion) => {
        setPropValue('beneficiario', datosFacturacion.razonSocial);
        setPropValue('pais', datosFacturacion.pais);
        setPropValue('estado', datosFacturacion.estado);
        setPropValue('municipio', datosFacturacion.municipio);
        setPropValue('calle', datosFacturacion.calle);
        setPropValue('colonia', datosFacturacion.colonia);
        setPropValue('codigoPostal', datosFacturacion.codigoPostal);
        setPropValue('numeroExterior', datosFacturacion.numExt);
        setPropValue('numeroInterior', datosFacturacion.numInt);
        setPropValue('correo', datosFacturacion.correo);
        setPropValue('correo2', datosFacturacion.correo);
        setPropValue('telefono', datosFacturacion.telefono);
        setPropValue('numregldtrib', datosFacturacion.numRegLdTrib);
        setPropValue('paisFiscal', datosFacturacion.pais);
    };

    const setDefaultData = () => {
        setPropValue('pais', DATOFISCAL_PAIS);
        setPropValue('estado', DATOFISCAL_ESTADO);
        setPropValue('municipio', DATOFISCAL_MUNICIPIO);
        setPropValue('calle', DATOFISCAL_CALLE);
        setPropValue('colonia', DATOFISCAL_COLONIA);
        setPropValue('codigoPostal', DATOFISCAL_CODIGOPOSTAL);
        setPropValue('numeroExterior', DATOFISCAL_NUMEROEXTERIOR);
        setPropValue('regimenFiscal', DATOFISCAL_REGIMENFISCAL);
        setPropValue('usoCFDI', DATOFISCAL_USOCFDI);
    };

    const changeForm = (rfc, tipo) => {
        setPropValue('rfc', rfc); 
        setDefaultData();
        setOtros(true);
        setTipo(tipo);
        setClicked(true);
        setNoFiscal(true);
    };

    const setRFC = (targetValue) => {
        setPersona(FISICA);
        setClicked(false);

        if (searched) {
            cleanForm();
            setSearched(false);
        }

        if(targetValue.length <= 11) {
            setClicked(true);
        } else if(targetValue.length === 12) {
            setPersona(MORAL);
        } else if(targetValue.length === 13) {
            if(targetValue === GENERICO_RFC) {
                Toast("La generación de su factura debe realizarse desde el apartado Acreditar propiedad");
                setErrores(".");
                changeForm(GENERICO_RFC, 2);
            } else if(targetValue === EXTRANJERO_RFC) {
                Toast("La generación de su factura debe realizarse desde el apartado Extranjero");
                setErrores(".");
                changeForm(EXTRANJERO_RFC, 3);
                setExtranjero(true);
            }
        }
    };

    const validateRFC = () => {
        let rfc = getValue("rfc");
       
        if(rfc != null) {
            if(rfc.length === 10) { 
                changeForm(GENERICO_RFC, 2);
                Toast("La generación de su factura debe realizarse desde el apartado Acreditar propiedad");
                setErrores(".");
            } else if(rfc.length === 12 || rfc.length === 13) {
                console.log(getValue("rfc"));
            } else {
                Toast("El RFC debe contener al menos 12 caracteres");
                setErrores(".");
            }
        }
    };

    const setBeneficiario = (event) => {
        let beneficiario = event.target.value;

        for(let i = 0; i < SOCIEDADES_MERCANTILES.length; i++) {
            if(beneficiario.includes(SOCIEDADES_MERCANTILES[i])) {
                let sociedad = beneficiario.search(SOCIEDADES_MERCANTILES[i]);
                if(sociedad != -1) {
                    beneficiario = beneficiario.substring(0, sociedad);
                    setPropValue('beneficiario', beneficiario);
                    Swal.fire("No debe incluir la sociedad mercantil");
                    break;
                }
            }
        }
    }

    const notificarUsoCFDI = () => {
        Swal.fire({
            title: '<strong>Aviso Importante</strong>',
            padding: '3em',
            html: '<p align="justify">Apreciable cliente' +
                  ' de acuerdo al catálogo de usos de comprobantes publicado por el SAT,' +
                  ' el uso de su comprobante únicamente podrá ser <b>S01 SIN EFECTOS FISCALES.</b></p>'
        })
    };

    const setRegimenFiscal = (targetValue) => {
        let regimenValido = NO_FISCALES.find(regimen => regimen == targetValue);
        if(regimenValido) {
            setPropValue("usoCFDI", 22);
            setAsalariado(true);
            notificarUsoCFDI();
        } else {
            setAsalariado(false);
        }
    };

    const getOpcionesRegimenFiscal = () => {
        if(regimenFiscal && regimenFiscal.length > 0) { 
            if(persona === FISICA) {
                return regimenFiscal.filter((uso) => uso.fisica === 1).map((regimen) => (
                    <option key={regimen.clave} value={regimen.idRegimenFiscal}>{regimen.clave} {regimen.descripcion}</option>
                ));   
            } else {
                return regimenFiscal.filter((uso) => uso.moral === 1).map((regimen) => (
                    <option key={regimen.clave} value={regimen.idRegimenFiscal}>{regimen.clave} {regimen.descripcion}</option>
                ));
            }
        }
    };

    const handleTipo = (event, tipo) => {
        setErrores('');
        setExtranjero(false);
        setPersona(FISICA);
        setAsalariado(false);
        setNoFiscal(false);
        cleanForm();

        switch (tipo) {
            case 1:
                setPropValue('rfc', '');
                setOtros(false);
                setTipo(1);
                break;
            case 2:
                changeForm(GENERICO_RFC, 2);
                setPropValue('beneficiario', "PÚBLICO EN GENERAL")
                break;
            case 3:
                changeForm(EXTRANJERO_RFC, 3);
                setExtranjero(true);
                break;
            default:
                setTipo(1);
        }
    };

    const handleRFC = (rfc) => {
        setSubmit(true);
        let rfcRequest = { rfc: getValue("rfc") }
        if( rfcRequest.rfc === GENERICO_RFC || rfcRequest.rfc === EXTRANJERO_RFC ) {
            setIsBuscando(false);
            Toast("Ingrese los datos, para generar su factura");
            setErrores(".");
            setSubmit(false);
        } else {
            cleanForm();
            axios.post(requests.facturacionGeneral.informarRFC, rfcRequest)
            .then(res => {
                //console.log(res.data)
                setSearched(false);
                setIsBuscando(false);
                setSubmit(false);
                setClicked(true);
                setErrores("");
                if(res.data.code === EXITO) {
                    setFormData(res.data.datosFacturacion);
                    setSearched(true);
                } else {
                    Toast("No se han encontrado los datos para el RFC ingresado");
                    setErrores(".");
                    setClicked(true);
                }
            }).catch((error) => {
                setIsBuscando(false);
                setErrores("Ha ocurrido un error, pongase en contacto con Servicio al Cliente Chapur");
            });
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsBuscando(true);
        setErrores("");

        if(getValue("correo") !== getValue("correo2")) {
            setIsBuscando(false);
            Toast("Los correos ingresados deben coincidir");
            setErrores('.');
            setPropValue("correo2", "");
        } else if (getValue("rfc") === GENERICO_RFC && tipo === 1) {
            setIsBuscando(false);
            Toast("Dirijase al apartado Acreditar propiedad para facturar su compra con el RFC Genérico");
            setErrores('.');
        } else if (getValue("rfc").length <= 11){
            setPropValue("rfc", GENERICO_RFC);
            setIsBuscando(false);
            Toast("RFC incorrecto, debe contener más de 11 caracteres");
            setErrores('.');
        }else {
            let datosFacturacion = {
                idInterno: [idNetsuite],
                data: {
                    rfc: getValue("rfc"),
                    usoCfdi: getValue("usoCFDI"),
                    numRegLdTrib: getValue("numregldtrib"),
                    regimenFiscal: getValue("regimenFiscal"),
                    razonSocial: getValue("beneficiario"),
                    pais: getValue("pais"),
                    estado: getValue("estado"),
                    municipio: getValue("municipio"),
                    calle: getValue("calle"),
                    colonia: getValue("colonia"),
                    codigoPostal: getValue("codigoPostal"),
                    numExt: getValue("numeroExterior"),
                    numInt: getValue("numeroInterior"),
                    correo: getValue("correo"),
                    telefono: getValue("telefono"),
                    idFacturaCompra: idCompra ? idCompra : ""
                }
            };
            console.log(datosFacturacion);
            axios.post(requests.facturacionGeneral.generarFactura, datosFacturacion)
            .then(res => {
                console.log(res.data);
                let code = res.data.mensaje.codigo;
                let mensaje = res.data.mensaje.descripcion;
                if (code === 1) {
                    setPropValue('rfc', "");
                    cleanForm();
                    parametrosBusqueda.mensaje = "Los documentos serán enviados al correo proporcionado.";
                    dispatch(setParametrosBusqueda(parametrosBusqueda));

                    props.nextStep();
                } else {
                    setIsBuscando(false);
                    if (code === 0) {
                        console.log(mensaje);
                        Toast(mensaje);
                        setErrores(mensaje);
                    } else {
                        Toast("Ha ocurrido un error, pongase en contacto con Servicio al Cliente Chapur");
                        setErrores(".");
                    }
                }
            }).catch(error => {
                setIsBuscando(false);
                setErrores("Verifique todos los datos obligatorios.");
            });
        }
    };

    return (
        <Fragment>
            <h3>Ingresa los datos para tu facturación</h3>
            <p className="mb-40">Si ya ha facturado anteriormente con nosotros, solo introduzca el R.F.C. y actualice
                sus datos.</p>

            {!soloGenerico ?
                (<div className="ctipo mb-40">
                    <div className="btn-group btn-group-lg" role="group" aria-label="button group">
                        <button type="button"
                                className={`btn btn-secondary ${tipo === 1 ? "active" : ""}`}
                                onClick={(event) => {
                                    handleTipo(event, 1)
                                }}>
                            <FontAwesomeIcon className="feature-box__icon" icon={faMale}/><br/>
                            Física/Moral
                        </button>
                        <button type="button"
                                className={`btn btn-secondary ${tipo === 2 ? "active" : ""}`}
                                onClick={(event) => {
                                    handleTipo(event, 2)
                                }}>
                            <FontAwesomeIcon className="feature-box__icon" icon={faHandshake}/><br/>
                            Acreditar propiedad
                        </button>
                        <button type="button"
                                className={`btn btn-secondary ${tipo === 3 ? "active" : ""}`}
                                onClick={(event) => {
                                    handleTipo(event, 3)
                                }}>
                            <FontAwesomeIcon className="feature-box__icon" icon={faGlobeAmericas}/><br/>
                            Extranjero
                        </button>
                    </div>
                </div>) : ''
            }

            {(error !== null && error !== '') ?
                <Toaster /> : ''
            }

            <form onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group col-md-3">
                        <label htmlFor="rfc">RFC*</label>
                        <input
                            type="text"
                            className="form-control"
                            id="rfc"
                            placeholder="RFC"
                            name="rfc"
                            autoComplete="off"
                            onChange={setForm}
                            onBlur={validateRFC}
                            maxLength="13"
                            value={getValue('rfc') || ''}
                            readOnly={buscando || soloGenerico || otros}
                        />
                    </div>
                    <div className="form-group col-md-3">
                        <div className='button-center'>
                            <button type="button" className="btn btn-lg btn-chapur btn-block" disabled={clicked}
                                onClick={handleRFC}>
                            {!submit ? 'Buscar' : 'Buscando...'}
                            {submit && <Spinner/>}
                            </button>
                        </div>
                    </div>
                    <div className="form-group col-md-6">
                        <div>
                            <label htmlFor="beneficiario">Beneficiario*</label>
                            <button type='button' className='btn btn-help' onClick={() => Alert(beneficiario, 'Beneficiario', 250)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>
                        </div>
                        <input type="text"
                               className="form-control"
                               id="beneficiario"
                               autoComplete="off"
                               name="beneficiario"
                               onChange={setForm}
                               value={getValue('beneficiario') || ''}
                               onBlur={setBeneficiario}
                               disabled={buscando}
                               maxLength="300"
                               placeholder="Beneficiario"/>
                        <div>Nombre o Razón social sin incluir el régimen de capital</div>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label htmlFor="pais">País*</label>
                        <input type="text"
                               className="form-control"
                               id="pais"
                               autoComplete="off"
                               name="pais"
                               onChange={setForm}
                               value={getValue('pais') || ''}
                               disabled={buscando}
                               maxLength="50"
                               placeholder="País"
                               readOnly={otros}/>
                    </div>
                    <div className="form-group col-md-4">
                        <label htmlFor="inputAddress2">Estado*</label>
                        <input type="text"
                               className="form-control"
                               id="estado"
                               autoComplete="off"
                               name="estado"
                               onChange={setForm}
                               value={getValue('estado') || ''}
                               disabled={buscando}
                               maxLength="50"
                               placeholder="Estado"
                               readOnly={otros}/>
                    </div>
                    <div className="form-group col-md-4">
                        <label htmlFor="municipio">Municipio*</label>
                        <input type="text"
                               className="form-control"
                               id="municipio"
                               autoComplete="off"
                               name="municipio"
                               onChange={setForm}
                               value={getValue('municipio') || ''}
                               disabled={buscando}
                               maxLength="60"
                               placeholder="Municipio"
                               readOnly={otros}/>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-md-2">
                        <label htmlFor="calle">Calle*</label>
                        <input type="text"
                               className="form-control"
                               id="calle"
                               name="calle"
                               placeholder="Calle"
                               onChange={setForm}
                               value={getValue('calle') || ''}
                               disabled={buscando}
                               maxLength="80"
                               autoComplete="off"
                               readOnly={otros}/>
                    </div>
                    <div className="form-group col-md-3">
                        <label htmlFor="colonia">Colonia*</label>
                        <input type="text"
                               className="form-control"
                               id="colonia"
                               name="colonia"
                               placeholder="Colonia"
                               onChange={setForm}
                               value={getValue('colonia') || ''}
                               disabled={buscando}
                               maxLength="120"
                               autoComplete="off"
                               readOnly={otros}/>
                    </div>
                    <div className="form-group col-md-3">
                        <div>
                            <label htmlFor="codigoPostal">Código postal*</label>
                            <button type='button' className='btn btn-help' onClick={() => Alert(codigoPostal, 'Código Postal', 150)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>
                        </div>
                        <NumberFormat
                            allowNegative={false}
                            value={getValue('codigoPostal') || ''}
                            onChange={setForm}
                            disabled={buscando}
                            placeholder="Código Postal"
                            maxLength="10"
                            autoComplete="off"
                            decimalScale="0"
                            decimalSeparator={false}
                            className="form-control"
                            id="codigoPostal"
                            name="codigoPostal"
                            readOnly={otros}
                        />
                    </div>
                    <div className="form-group col-md-2">
                        <label htmlFor="numeroExterior">Num. Ext.*</label>
                        <input type="text"
                               className="form-control"
                               id="numeroExterior"
                               name="numeroExterior"
                               placeholder="Número exterior"
                               onChange={setForm}
                               value={getValue('numeroExterior') || ''}
                               disabled={buscando}
                               maxLength="50"
                               autoComplete="off"
                               readOnly={otros}/>
                    </div>
                    <div className="form-group col-md-2">
                        <label htmlFor="numeroInterior">Num. Int.</label>
                        <input type="text"
                               className="form-control"
                               id="numeroInterior"
                               name="numeroInterior"
                               placeholder="Número Interior"
                               onChange={setForm}
                               value={getValue('numeroInterior') || ''}
                               disabled={buscando}
                               maxLength="50"
                               readOnly={otros}
                               autoComplete="off"/>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-md-4">
                        <label htmlFor="correo">Correo electrónico*</label>
                        <input type="text"
                               className="form-control"
                               id="correo"
                               autoComplete="off"
                               name="correo"
                               placeholder="Correo electrónico"
                               onChange={setForm}
                               value={getValue('correo') || ''}
                               maxLength="75"
                               disabled={buscando}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label htmlFor="correo2">Confirmación correo*</label>
                        <input type="text"
                               className="form-control"
                               id="correo2"
                               autoComplete="off"
                               name="correo2"
                               placeholder="Confirmar correo electrónico"
                               onPaste={confirmCorreo}
                               onBlur={validateCorreo}
                               onChange={setCorreo}
                               value={getValue('correo2') || ''}
                               maxLength="75"
                               disabled={buscando}
                        />
                    </div>
                    <div className="form-group col-md-4">
                        <label htmlFor="telefono">Teléfono</label>
                        <NumberFormat
                            allowNegative={false}
                            value={getValue('telefono') || ''}
                            onChange={setForm}
                            disabled={buscando}
                            placeholder="Teléfono"
                            autoComplete="off"
                            decimalScale="0"
                            format="(###) #######" mask="_"
                            decimalSeparator={false}
                            className="form-control"
                            id="telefono"
                            name="telefono"
                        />
                    </div>
                </div>

                <div className='form-row'>
                    <div className="form-group col-md-6" style={{ display: extranjero ? "block" : "none"}}>
                        <label htmlFor="numregldtrib">NUMREGLDTRIB</label>
                        <input type="text"
                            className="form-control"
                            id="numregldtrib"
                            autoComplete="off"
                            name="numregldtrib"
                            placeholder="Registro de Identidad Fiscal"
                            onChange={setForm}
                            value={getValue('numregldtrib') || ''}
                            maxLength="75"
                            disabled={buscando}
                        />
                    </div>
                    <div className="form-group col-md-6" style={{ display: extranjero ? "block" : "none"}}>
                        <label htmlFor="paisFiscal">País fiscal</label>
                        <input type="text"
                            className="form-control"
                            id="paisFiscal"
                            autoComplete="off"
                            name="paisFiscal"
                            placeholder="País Fiscal"
                            onChange={setForm}
                            value={getValue('paisFiscal') || ''}
                            maxLength="75"
                            disabled={buscando}
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group col-md-6">
                        {/* 
                        <div>
                            <label htmlFor="regimenFiscal">Régimen Fiscal del Receptor*</label>
                            <button type='button' className='btn btn-help' onClick={() => Alert(FISCAL_REGIMENFISCAL, 'Régimen Fiscal', 60)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button>
                        </div> 
                        --AJ8, 31/01/23 */}

                        <label htmlFor="regimenFiscal">Régimen Fiscal del Receptor*</label>
                        <select
                            className="form-control"
                            id="regimenFiscal"
                            name="regimenFiscal"
                            value={getValue('regimenFiscal') || '0'}
                            onChange={setForm}
                            disabled={buscando || noFiscal}
                            readOnly={otros}
                        >
                            
                            <option key={-1} value="0" disabled>Seleccionar Régimen Fiscal</option>
                            {getOpcionesRegimenFiscal()}
                        </select>
                    </div>

                    <div className="form-group col-md-6">
                        {/* 
                        <div>
                            <label htmlFor="usoCFDI">Uso CFDI*</label>
                            <button type='button' className='btn btn-help' onClick={() => Alert(FISCAL_USOCFDI, 'Uso CFDI', 300)}>
                                <FontAwesomeIcon className="feature-box__icon feature-box__icon--small"
                                                icon={faQuestionCircle}/>
                            </button> 
                        </div> 
                        --AJ8, 31/01/23 */}
                        
                        <label htmlFor="usoCFDI">Uso CFDI*</label>
                        <select
                            className="form-control"
                            id="usoCFDI"
                            name="usoCFDI"
                            value={getValue('usoCFDI') || '0'}
                            onChange={setForm}
                            disabled={buscando || asalariado || noFiscal}
                            readOnly={otros}
                        >
                            <option key={-1} value="0" disabled>Seleccionar Uso CFDI</option>
                            {usoCFDI != null && usoCFDI.map((uso, i) => (
                                <option key={i} value={uso.idUsoCFDI}>{uso.clave} {uso.descripcion}</option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="form-row">
                    <div className='button-main'>
                        <button type="submit" className="btn btn-lg btn-primary btn-block mt-30"
                                disabled={buscando || disabledButton()}>
                            {!buscando ? 'Generar Factura' : 'Facturando...'}
                            {buscando && <Spinner/>}
                        </button>
                    </div>
                </div>
            </form>
        </Fragment>);
};

export default DatosFiscales;